import { AuthProvider } from "@refinedev/core";
import axios from "axios";
import { clearPermissionsCache } from "../providers/accessControlProvider";

const API_BASE_URL = import.meta.env.VITE_API_URL
const AUTH_SERVICE_URL = import.meta.env.VITE_AUTH_URL
const RETURN_URL = import.meta.env.VITE_BASE_URL

// Create axios instance with credentials
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Function to redirect to external auth service
const redirectToAuthService = () => {
  const returnUrl = encodeURIComponent(RETURN_URL);
  console.log({returnUrl})
  window.location.href = `${AUTH_SERVICE_URL}/auth/signin?returnUrl=${returnUrl}`;
};

export const authProvider: AuthProvider = {
  login: async () => {
    // Since we're using an external auth service, we redirect directly
    redirectToAuthService();
    return {
      success: true,
    };
  },
  logout: async () => {
    try {
      // Call logout endpoint if available
      await axios.get(`${AUTH_SERVICE_URL}/api/logout`, {
        withCredentials: true,
      });
    } catch (error) {
      // Even if logout fails, we still want to redirect to auth service
      console.error("Logout error:", error);
    } finally {
      clearPermissionsCache();
      // Redirect to auth service for login
      //redirectToAuthService();
    }
    
    return {
      success: true,
    };
  },
  check: async () => {
    try {
      // Check if user is authenticated by calling the /api/auth/me endpoint
      await apiClient.get("/auth/me");
      return {
        authenticated: true,
      };
    } catch (error) {
      // If we get a 401, redirect to auth service
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        redirectToAuthService();
        return {
          authenticated: false,
          redirectTo: AUTH_SERVICE_URL,
        };
      }
      
      // For other errors, still consider the user unauthenticated
      return {
        authenticated: false,
        redirectTo: AUTH_SERVICE_URL,
      };
    }
  },
  getIdentity: async () => {
    try {
      // Get user identity from /api/auth/me endpoint
      const response = await apiClient.get("/auth/me");
      const user = response.data;
      // console.log("User identity:", user);
      
      return {
        id: user._id,
        name: user.firstName || user.email,
        email: user.email,
        avatar: user.avatar,
      };
    } catch (error) {
      // If we can't get user identity, redirect to auth service
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        redirectToAuthService();
      }
      return null;
    }
  },
  getPermissions: async () => {
    try {
      // Get user permissions from /api/auth/me endpoint
      const response = await apiClient.get("/auth/me");
      const user = response.data;
      
      // Return user permissions/roles
      return user.permissions || user.roles || [];
    } catch (error) {
      // If we can't get permissions, redirect to auth service
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        redirectToAuthService();
      }
      return null;
    }
  },
  onError: async (error) => {
    // Handle authentication errors
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      redirectToAuthService();
      return {
        logout: true,
        redirectTo: AUTH_SERVICE_URL,
      };
    }
    
    return { error };
  },
};